// The /live connection badge. Reconnects are silent (the stream retries with exponential
// backoff and jitter, capped at 30 s); the badge admits a problem only after BADGE_DELAY_MS of
// sustained failure, and never shows an attempt counter.
import type { StreamStatus } from "./stream";

export const BADGE_DELAY_MS = 10_000;

export interface Conn { s: StreamStatus; since: number; wasLive: boolean }   // since: when s began

export function badgeFor(c: Conn, now: number): { status: "live" | "connecting" | "reconnecting"; text: string } {
  if (c.s === "live") return { status: "live", text: "Live" };
  if (now - c.since >= BADGE_DELAY_MS) return { status: "reconnecting", text: "Reconnecting…" };
  return c.wasLive ? { status: "live", text: "Live" } : { status: "connecting", text: "" };
}
